export default __webpack_public_path__ + "static/media/2026-03-27 12.29.50.388b9477.jpg";